<form [formGroup]="writeInForm">
    <div class="flex-container" 
        [ngClass]="{'selected': choice().selected,
        'focused': inputHasFocus}"
        (click)="handleContainerClick($event)">

        <!-- Oval is on the Left -->
        @if(!ovalOnRight){
            <label class="custom-checkbox">
                <input type="checkbox" formControlName="checkboxControl"
                    (click)="handleContainerClick()"
                    (keydown)="handleKeyPress($event)"
                    (focus)="handleFocus()"
                    (blur)="handleBlur()"
                    aria-label="Write-In"
                    tabindex="0">
                <span class="checkmark"></span>
            </label>
            <input class="write-in-right" type="text" formControlName="writeInControl"
                i18n-placeholder [placeholder]="jsonDescription" [maxlength]="maxLength+1" >
        }
 
        <!-- Oval is on the Right -->
        @if(ovalOnRight){
            <input class="write-in-left" type="text" formControlName="writeInControl"
               i18n-placeholder [placeholder]="jsonDescription" [maxlength]="maxLength+1" >
            <label class="custom-checkbox">
                <input type="checkbox" formControlName="checkboxControl"
                    (click)="handleContainerClick()"
                    (keydown)="handleKeyPress($event)"
                    (focus)="handleFocus()"
                    (blur)="handleBlur()"
                    tabindex="0">
                <span class="checkmark"></span>
            </label>
        }
 

    </div>
    @if(writeInForm.get('writeInControl')?.hasError('maxlength')){
        <div i18n class="error-message" aria-live="assertive" role="alert">
            <img src="/assets/images/warning.svg" alt="alert" width="30" height="30"> &nbsp; Maximum allowed length is {{maxLength}} characters.
        </div>
    }
    @if(writeInForm.get('writeInControl')?.dirty && writeInForm.get('writeInControl')?.hasError('specialChars')){
        <div i18n class="error-message"  aria-live="assertive" role="alert">
            <img src="/assets/images/warning.svg" alt="alert" width="30" height="30">&nbsp; Special characters are not allowed.
          </div>
    }    
</form>
